var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project"},[_c('complexProjectViewer',{attrs:{"name":_vm.name,"incognitoName":_vm.incognitoName,"incognitoMode":_vm.incognitoMode,"platforms":_vm.platforms,"bgColor":_vm.bgColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }